/* eslint-disable */
// <auto-generated>
// Generated by projects/template-ui/scripts/generate-contract-types.ts.
// Source: api/src/Riley.Jms.Application/Schemas/schema-manifest.json.
// </auto-generated>

export interface WorkflowReviewLookupRequest {
  expectedETag: string;
  occurrenceId: number;
  workSummary: string;
  workSummaryLookupRevision?: string | null;
}

export const WorkflowReviewLookupRequestForm = {
  "contract": "WorkflowReviewLookupRequest",
  "version": 1,
  "fields": [
    {
      "name": "workSummary",
      "type": "string",
      "control": "textarea",
      "label": "Work submitted for review",
      "labelToken": "workflow.review.workSummary",
      "required": true,
      "nullable": false,
      "minLength": 1,
      "maxLength": 4000,
      "errorCodes": [
        "workflow.review.work_required"
      ],
      "supportsLayout": true,
      "supportsLookup": true
    }
  ]
} as const;
